import React from 'react';
import { Gift } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function BonusStack() {
  const bonuses = [{
    id: 1,
    title: 'Kit de Checklists Clínicos de Bolsillo',
    desc: '12 checklists listos para evaluar cada región sin olvidarte de ningún paso importante.',
    value: '$8.000'
  }, {
    id: 2,
    title: 'Mapa Maestro de Tests y Maniobras',
    desc: 'Una guía visual para saber qué test usar, cuándo y por qué según la región y la sospecha.',
    value: '$10.000'
  }, {
    id: 3,
    title: 'Plantillas de Registro de Evaluación Listas para Usar',
    desc: '10 fichas clínicas por región listas para imprimir y completar en prácticas o consulta.',
    value: '$9.000'
  }, {
    id: 4,
    title: 'Guía Rápida de Red Flags y Derivación Segura',
    desc: 'Detectá señales de alarma y sabé cuándo y cómo derivar con criterio y seguridad clínica.',
    value: '$8.000'
  }, {
    id: 5,
    title: 'Resúmenes Visuales de Diagnóstico Diferencial',
    desc: 'Comparativas claras para diferenciar cuadros parecidos y razonar con más velocidad clínica.',
    value: '$9.000'
  }, {
    id: 6,
    title: 'Plan de Estudio Clínico de 21 Días',
    desc: 'Un sistema claro para estudiar el Atlas sin perderte ni abrumarte, con tracker de progreso incluido.',
    value: '$9.000'
  }];
  return <AnimatedSection className="bg-navy-900 border-y border-dark-border" data-id="element-21">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-12 sm:mb-16" data-id="element-23">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-bold mb-3 sm:mb-4 leading-tight" data-id="element-24">
            <span className="text-gold" data-id="element-25">🎁 6 BONOS ESTRATÉGICOS</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-300" data-id="element-26">
            Siempre incluidos. Listos para usar desde el primer día.
          </p>
        </div>

        <div className="space-y-4 sm:space-y-6" data-id="element-27">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-dark-card border border-dark-border rounded-xl p-5 sm:p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 sm:gap-6 relative overflow-hidden group" data-id="element-28">
              <div className="absolute top-0 left-0 w-1 h-full bg-gold" data-id="element-29"></div>

              <div className="flex-1 pl-3 sm:pl-0" data-id="element-30">
                <div className="text-gold text-xs sm:text-sm font-bold mb-2 uppercase tracking-wider flex items-center gap-2" data-id="element-31">
                  <Gift size={16} data-id="element-32" /> Bono {bonus.id}
                </div>
                <h3 className="text-lg sm:text-xl md:text-2xl font-heading font-bold text-white mb-2 leading-tight" data-id="element-33">
                  {bonus.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed" data-id="element-34">
                  {bonus.desc}
                </p>
              </div>

              <div className="flex flex-col items-end flex-shrink-0 bg-navy-950 p-3 sm:p-4 rounded-lg border border-dark-border w-full md:w-auto text-center md:text-right" data-id="element-35">
                <span className="text-gray-500 line-through text-base sm:text-lg" data-id="element-36">
                  {bonus.value}
                </span>
                <span className="text-green-400 font-bold text-xl sm:text-2xl" data-id="element-37">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="mt-10 sm:mt-12 text-center bg-gold/10 border border-gold/30 rounded-xl p-6 sm:p-8" data-id="element-38">
          <p className="text-lg sm:text-xl md:text-2xl font-heading font-bold text-white leading-tight" data-id="element-39">
            Valor total de bonos:{' '}
            <span className="line-through text-gray-400" data-id="element-40">$53.000</span>{' '}
            <span className="text-gold" data-id="element-41">→ GRATIS con tu Atlas Clínico</span>
          </p>
        </div>
      </div>
    </AnimatedSection>;
}